import { I18nComponente } from "@/types/gerais"

export const TProfissionali18n: I18nComponente = {
  "pt-BR": {
    criarProfissional: "criar profissional",
    criarCategoria: "criar categoria",
  },
  "es-CO": {
    criarProfissional: "añadir profesional",
    criarCategoria: "añadir categoría",
  }
}
